/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React from 'react'
import StatusIndicator from '../../../../components/StatusIndicator';
import Noresult from '../Noresult';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip'
import Tabledata from '../../../../components/Shimmer/TableData';
import { checkPrivilege } from '../../../../CommonMethods/checkPrivilege';

export default function TableSection({ List, handleSearchParams, searchParams, setmodalpopup, modalpopup, tableLoading, privilegeRequired }) {
    const arr = [];
    const totaldata = arr.length;
    const navigate = useNavigate();
    const handleSort = (key) => {
        let sortValue = searchParams.get('sort');
        if (sortValue === null) handleSearchParams('sort', `${key}+asc`);

        else {
            let newKey = sortValue.endsWith('+desc') ? `${key}+asc` : `${key}+desc`
            handleSearchParams('sort', newKey)
        }
    }
    const hasPrivilege = checkPrivilege(privilegeRequired);
    const hasActivatePrivilege = checkPrivilege('activate_or_deactivate_admin_user')
    const CheckSort = (key) => searchParams.get('sort') !== null && searchParams.get('sort') === `${key}+asc`

    // return (
    //     <div className='bg-white px-4 mt-12 overflow-auto adminUserHeight sidebar'>
    //         {List?.data?.length === 0 ? <Noresult /> : <table className="w-full">
    //             <thead>
    //                 <tr className="border-b-[1px] border-[#EEEEEE]">
    //                     <th className="flex space-x-1 px-4 py-3">
    //                         <h1 className="text-sm">Name</h1>
    //                         <img className='cursor-pointer' src="/assets/images/sort.svg" alt="" onClick={() => handleSort('name')} />
    //                     </th>
    //                     <th className="pl-[100px] py-3">
    //                         <h1 className="text-sm text-[#4B4B4B] font-medium text-left">Email Address</h1>
    //                     </th>
    //                     <th className="px-4 py-3 ">
    //                         <h1 className="text-sm text-[#4B4B4B] font-medium  text-left">Phone Number</h1>
    //                     </th>
    //                     <th className="flex space-x-1 px-4 py-3 justify-center">
    //                         <h1 className="text-sm">Status</h1>
    //                         <img src="/assets/images/sort.svg" alt="" onClick={() => handleSort('status')} />
    //                     </th>
    //                     <th className="px-4 py-3">
    //                         <h1 className="text-sm text-[#4B4B4B] font-medium">Action</h1>
    //                     </th>
    //                 </tr>
    //             </thead>
    //             <tbody>
    //                 {List?.data?.map((item, index) => (
    //                     <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
    //                         <td className="px-4 py-3">
    //                             <h1 className="text-sm">{item.name}</h1>
    //                         </td>
    //                         <td className="px-4 pl-[100px] py-3 ">
    //                             <h1 className="text-sm text-left">{item.email_address}</h1>
    //                         </td>
    //                         {/* <td className="px-4 py-3">
    //                             <h1 className="text-sm text-center">{item.phone_number}</h1>
    //                         </td>
    //                         <td className="px-4 py-3 ">
    //                             {item.status!==''?<StatusIndicator item={item} setmodalpopup={setmodalpopup} status={item.status===true?'true':'false'} />:'-'}
    //                         </td>
    //                         <Link to={`/manage-admin-users/${item['_id']}/edit`}>
    //                             <td className="px-4 py-3 flex justify-center">
    //                                 <img src="/assets/images/Edit.svg" alt="" />
    //                             </td> */}
    //                         <td className="px-4 py-3">
    //                             <h1 className="text-sm text-[#4B4B4B] font-normal text-left">{item.phone_number}</h1>
    //                         </td>
    //                         <td className="px-4 py-3 ">
    //                             {item.status !== '' ? <StatusIndicator item={item} setmodalpopup={setmodalpopup} hasPrivilege={hasActivatePrivilege} status={item.status === true ? 'true' : 'false'} /> : '-'}
    //                         </td>
    //                         {/* {checkPrivilege(privilegeRequired) &&

    //                             } */}
    //                         {/* <Link to={`/manage-admin-users/${item['_id']}/edit`}> */}
    //                         <td className="px-4 py-3 flex justify-center">
    //                             <div className='relative add_tooltip' data-tooltip-id={item._id}>
    //                                 <img src="/assets/images/Edit.svg" className={`${hasPrivilege ? '' : 'cursor-not-allowed'}`} onClick={() => {
    //                                     if (hasPrivilege) {
    //                                         navigate(`/manage-admin-users/${item['_id']}/edit`);
    //                                     }
    //                                 }} alt="" />
    //                             </div>
    //                             <Tooltip
    //                                 id={item._id}
    //                                 place="right"
    //                                 content="Edit"
    //                             />
    //                         </td>
    //                         {/* </Link> */}
    //                     </tr>
    //                 ))}
    //             </tbody>

    //         </table>}

    //     </div>
    // )
    return (
        <div className='bg-white px-4 mt-10 overflow-auto adminUserHeight sidebar' data-testid="admin-table">
            {List?.data?.length === 0 ? <Noresult /> : <table className="w-full overflow-auto scrollBar">
                <thead className='sticky top-0 right-0 z-[9] bg-white'>
                    <tr className="border-b-[1px] border-[#EEEEEE]">
                        <th className="flex space-x-1 px-4 py-3">
                            <h1 className="text-sm text-[#4B4B4B] font-medium">Admin Name</h1>
                            <img src="/assets/images/sort-pink.svg" alt="" data-testid="admin-sort_name" onClick={() => handleSort('name')}
                                className={`cursor-pointer ${CheckSort('name') ? 'rotate-180' : ''}`} />
                        </th>
                        <th className="pl-[100px] py-3">
                            <h1 className="text-sm text-[#4B4B4B] font-medium text-left">Email Address</h1>
                        </th>
                        <th className="px-4 py-3 ">
                            <h1 className="text-sm text-[#4B4B4B] font-medium  text-left">Phone Number</h1>
                        </th>
                        <th className="flex space-x-1 px-4 py-3 text-start">
                            <h1 className="text-sm text-[#4B4B4B] font-medium">Status</h1>
                            <img src="/assets/images/sort-pink.svg" alt="" data-testid="admin-sort_status" onClick={() => handleSort('status')}
                                className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} />
                        </th>
                        <th className="px-4 py-3">
                            <h1 className="text-sm text-[#4B4B4B] font-medium">Action</h1>
                        </th>
                    </tr>
                </thead>
                {tableLoading ? <Tabledata column={5} /> :
                    (<tbody>
                        {List?.data?.map((item, index) => (
                            <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                <td className="px-4 py-4">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal max-w-[170px] text-ellipsis overflow-hidden whitespace-nowrap">{item.name}</h1>
                                </td>
                                <td className="px-4 pl-[100px] py-4 ">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal text-left max-w-[300px] text-ellipsis overflow-hidden whitespace-nowrap">{item.email_address}</h1>
                                </td>
                                <td className="px-4 py-4">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal text-left max-w-[170px] text-ellipsis overflow-hidden whitespace-nowrap">{item.phone_number}</h1>
                                </td>
                                <td className="px-4 py-4 ">
                                    {item.status !== '' ? <StatusIndicator item={item} setmodalpopup={setmodalpopup} hasPrivilege={hasActivatePrivilege} status={item.status === true ? 'true' : 'false'} testid={`toggle-btn-${index}`}/> : '-'}
                                </td>
                                {/* <Link to={`/manage-admin-users/${item['_id']}/edit`}> */}
                                <td className="px-4 py-4 flex justify-center">
                                    <div className='relative add_tooltip' data-tooltip-id={item._id} data-testid={`view-btn-${index}`}>
                                        <img src="/assets/images/Edit.svg" className={`${hasPrivilege ? '' : 'cursor-not-allowed'}`}
                                            onClick={() => {
                                                if (hasPrivilege) {
                                                    navigate(`/manage-admin-users/${item['_id']}/edit`);
                                                }
                                            }}
                                            alt="" />
                                    </div>
                                    <Tooltip
                                        id={item._id}
                                        place="right"
                                        content="Edit"
                                    />
                                </td>
                                {/* </Link> */}
                            </tr>
                        ))}
                    </tbody>)
                }
            </table>}

        </div>
    )
}
